import { defineStore } from 'pinia';
import piniaPersistConfig from "@/stores/piniaPersist";

export interface UserResponse {
  uuid: string;
  uname: string;
  ucompany: number;
  job_title: string;
  avatar_url: string;
}

export const useUserInfoStore = defineStore('userinfo',{

  state: (): { user: UserResponse | null } => ({
    user: null
  }),

  actions: {
    setUser(user: UserResponse) {
      this.user = user;
    },
    clearUser() {
      this.user = null;
      localStorage.removeItem('userinfo');
    }
  },
  persist: piniaPersistConfig("userinfo")
});